$(document).ready(function(){
    // When .searchmenu is clicked
    $('.searchmenu').on('click', function(e) {
      e.stopPropagation(); // Prevent event from bubbling up to the document
      // Add .hidden to all .submenu elements
      $('.searchmenu .submenu').addClass('hidden');
      // Toggle .hidden on the .submenu under the clicked .searchmenu
      $(this).find('.submenu').toggleClass('hidden');
    });
  
    // When any other part of the document is clicked
    $(document).on('click', function() {
      // Add .hidden to all .submenu elements if they don't already have it
      $('.searchmenu .submenu').addClass('hidden');
    });
    

    var swiper = new Swiper('.firstview__slider .swiper-container', {
        // オプションをここに設定
        loop: true,
        autoplay: {
            delay: 2500, // 2500ミリ秒（2.5秒）ごとにスライド
            //disableOnInteraction: false, // ユーザーの操作後も自動再生を続行
          },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });

  });
  
jQuery(function($){
    var targetURL = "https://sanei-sangyo.jp/wp-json/wp/v2/news/?_embed";

    $.ajax({
        type: 'GET',
        url: targetURL,
        dataType: 'json',
        timeout: 30000,
        success: function(data){       
            for(var i = 0 ; i < 3; i++){
                var date = new Date(data[i]["date"]);
                date = formatDate(date , "YYYY年MM月DD日");
                var title = data[i]["title"]["rendered"];
                var content = data[i]["content"]["rendered"];
                var newsId = data[i]["id"];
                var imageUrl = data[i]["_embedded"]["wp:featuredmedia"][0]["media_details"]["sizes"]["full"]["source_url"];

                var html = "<li class='news__item'>" +
                            "<div class='news__item-content'>" +
                                "<div class='news__image-container'>" +
                                    "<img class='news__image' alt='" + title + "' src='" + imageUrl + "'>" +
                                "</div>" +
                                "<div class='news__text-container'>" +
                                    "<div class='news__date'>" + date + "</div>" +
                                    "<h3 class='news__headline'>" + title + "</h3>" +
                                    "<div class='news__summary'>" + content + "</div>" +
                                    //"<div class='news__arrow'>" +
                                    //    "<i class='fas fa-arrow-right news__arrow-icon'></i>" +
                                    //"</div>" +
                                "</div>" +
                            "</div>" +
                           "</li>";
                $("#news_area").append(html);
            }            
        },
        error: function(){
            $("#news_area").append("<li>News could not be loaded at this time.</li>");
        }
    });

    function formatDate (date, format) {
        if (!format) format = 'YYYY年MM月DD日';
        format = format.replace(/YYYY/g, date.getFullYear());
        format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
        format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
        return format;
    };
});
